// extracted by mini-css-extract-plugin
export var contrastLow = "_43-1";
export var externalLink = "_43-2";
export var externalLinkIcon = "_43-3";
export var link = "_43-0";
export var linkLabel = "_43-4";